module.exports = __webpack_public_path__ + "static/media/4.a512e881.png";